







































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import L from 'leaflet';
import '../../node_modules/leaflet-plugins/layer/tile/Bing.js';
import 'leaflet.markercluster'; // This isn't used directly, but it is needed when using esriCluster
import * as esri from 'esri-leaflet';
// @ts-ignore - no types!
import * as esriCluster from 'esri-leaflet-cluster';
import 'leaflet.heat';

import 'mapbox-gl';
import 'mapbox-gl-leaflet';
import { Listing } from '../models/Listing';
import { Filter } from '../models/Filter';
import { CrimePoint } from '../models/CrimePoint';
import Defs from '../utils/Defs';
import ListingUtil from '../utils/ListingUtil';
import PreloadImage from '../workers/preloadImages';

@Component
export default class LayerManager extends Vue {

    public layerMenuShowing: boolean = false;

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'initLayers') {
            this.initLayers();
        }
        if (action.type === 'setSelectedListing') {
            console.log('selectedListingChanged!');
            console.log(action.payload);
            this.onSelectedListingChanged(action.payload);
        }
        if (action.type === 'filterChanged') {
            this.onFilterChanged();
        }
        if (action.type === 'heatmapDataLoaded') {
            this.onHeatmapDataLoaded();
        }
        if (action.type === 'goToListing') {
            this.onGoToListing(action.payload);
        }
        if (action.type === 'setMarkerLocation') {
            this.setSelectedFeatureMarkerCoordinates(action.payload);
        }
        // I'm pretty sure this sub isn't needed anymore
        // if (action.type === 'mapMoveEnd') {
        //     if (!this.isListingPointLayerLoading) {
        //         console.log('LayerMgr:_onMapMovedEnd - map NOT loading...');
        //         // _notifyNewFeaturesLoadedIntoMapBounds();
        //         // ->
        //         // var lFeatures = _getPointFeaturesWithinCurrentBounds();
        //         // RemapState.featuresWithinMapBoundsChanged(lFeatures);
        //     } else {
        //         // Logger.writeLog("LayerMgr:_onMapMovedEnd - map loading already...");
        //         console.log('LayerMgr:_onMapMovedEnd - map loading already...');
        //     }
        // }
    });

    public selectedFeatureMarker: L.Marker | null = null;
    public selectedCrimeMarker: L.Marker | null = null;
    public lastListingLayerSelected: esri.FeatureLayer | null = null;
    public listingPointsLayer: esri.FeatureLayer | null = null;
    public listingPolygonLayer: esri.FeatureLayer | null = null;
    public pointOpsLayer: esriCluster.featureLayer | null = null;
    public currentlyHighlightedPolygonId: string | null = null;
    public parcelVectorLayer: any = null; // type: mapboxGL
    public loadingTimerId: number | null = null;

    public listingPolygonErrorTracking = {
        NumLoadsInRowWithError: 0,
        IsErrorOnCurrentLoad: false,
        HasErrorBeenDisplayed: false,
        DelayToNextRefresh: 100,
        LatestError: '',
    };

    public listingPointErrorTracking = {
        NumLoadsInRowWithError: 0,
        IsErrorOnCurrentLoad: false,
        HasErrorBeenDisplayed: false,
        DelayToNextRefresh: 100,
        LatestError: '',
    };
    public isListingPointLayerLoading: boolean = true;
    public hasPendingFilterUpdate: boolean = false;
    public isHeatLayersInit = false;
    public isCrimeLayersInit = false;
    public isCrownLandLayerInit = false;
    public isForeignBuyerLayerInit = false;
    public pendingNewSelectedListingPid: string | null = null;
    public selectedParcelLayer: any = null;
    public layerSoldHeatMap: any | null = null; // L.HeatLayer types aren't working ?!
    public crimeLayer: esriCluster.featureLayer | null = null;
    public crownLandLayer: any = null;
    public foreignBuyerLayer: any = null;

    get map(): L.Map {
        return this.$store.state.map;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get config() {
        return this.$store.state.config;
    }

    get activeFilter(): Filter {
        return this.$store.state.filters.activeFilter;
    }

    get spatialFilter(): L.GeoJSON | null {
        return this.$store.state.filters.spatialFilter;
    }

    get heatmapData(): number[][] | null {
        return this.$store.state.layers.heatmapData;
    }

    // grab the inital state from config, but active state may be changed locally
    public layers = [ Object.assign({}, this.$store.state.config.ListingsPointLayer),
            Object.assign({}, this.$store.state.config.HeatmapLayer),
            Object.assign({}, this.$store.state.config.CrimeRecordsLayer)];

    public activeBasemap: esri.BasemapLayer | L.TileLayer | esri.TiledMapLayer | null = null;
    public activeBasemapLabels: esri.BasemapLayer | null = null;
    public basemaps: any = {};

    @Watch('layerMenuShowing', { immediate: false, deep: false })
    public layerMenuShowingChanged(value: boolean, oldValue: boolean) {
        if (value) {
            if (!this.isForeignBuyerLayerInit) {
                this.initForeignBuyerLayer();
            }
            if (!this.isCrownLandLayerInit) {
                this.initCrownLandLayer();
            }
            if (!this.isHeatLayersInit) {
                this.$store.dispatch('initHeatmapLayer');
                this.isHeatLayersInit = true;
            }
            if (!this.isCrimeLayersInit) {
                this.initCrimePointLayer();
                this.$store.dispatch('initCrimeLayer');
            }
        }
    }

    @Watch('activeFilter', { immediate: false, deep: true })
    public activeFilterChanged(value: Filter, oldValue: Filter) {
        console.log('LayerManager(): activeFilter changed!');
        this.onFilterChanged();
    }

    public initCrimePointLayer() {
        // Logger.writeLog("Init Crime Layer");
        console.log('LayerManager: initCrimePointLayer()');

        this.isCrimeLayersInit = true;
        this.crimeLayer = esriCluster.featureLayer({
            url: this.config.CrimeRecordsLayer.url,
            fields: ['*'],
            proxy: this.config.proxy.url,
            minZoom: this.config.ListingsPointLayer.minZoom,
            maxZoom: this.config.ListingsPointLayer.maxZoom,
            precision: this.config.ListingsPointLayer.precision,
            chunkedLoading: true,
            spiderfyOnMaxZoom: false,
            animate: false,
            disableClusteringAtZoom: 17,
            polygonOptions: {
                color: '#fba02f',
                weight: 4,
                opacity: 1,
                fillOpacity: 0.5,
            },
            // this function defines how the icons
            // representing  clusters are created
            iconCreateFunction: (cluster: any) => {
                // get the number of items in the cluster
                const count = cluster.getChildCount();
                // figure out how many digits long the number is
                const digits = (count + '').length;
                // return a new L.DivIcon with our classes so we can
                // style them with CSS. Take a look at the CSS in
                // the <head> to see these styles. You have to set
                // iconSize to null if you want to use CSS to set the
                // width and height.
                return new L.DivIcon({
                    html: count,
                    className: 'crimeCluster digits-' + digits,
                    iconSize: undefined,
                });
            },
            pointToLayer: (feature: any, latlng: any) => {
                return L.marker(latlng, {
                    icon: L.divIcon({
                        iconAnchor: [20, 20], // point of the icon which will correspond to marker's location
                        iconSize: [33, 35],
                        className: 'iconCrime',
                        html: `<div class='lblCrimePin'>` + feature.properties.NumCrimes + `</div>`,
                    }),
                });
            },
        });
        this.crimeLayer.on('click', this.onCrimePointClick);
    }

    public initCrownLandLayer() {
        this.isCrownLandLayerInit = true;

        this.crownLandLayer = new esri.FeatureLayer({
            url: this.config.CrownLandLayer.url,
            minZoom: this.config.CrownLandLayer.minZoom,
            maxZoom: this.config.CrownLandLayer.maxZoom,
            style: () => {
                return {color: 'orange'};
            },
        });

        const addFunction = this.addCrownLandLayerToLayerManager;
        this.crownLandLayer.metadata((error: any, metadata: any) => {
            if (metadata !== undefined && error === undefined) {
                addFunction();
            }
        });
    }

    public async initForeignBuyerLayer() {
        this.isForeignBuyerLayerInit = true;

        const response = await fetch(this.config.ForeignBuyerBanLayer.url);
        const geoJSONData = await response.json();

        this.foreignBuyerLayer = L.geoJSON(geoJSONData, {
            style: () => {
                return { color: '#A600FF', fillColor: '#55ff00', weight: 2, fillOpacity: 0.2 };
            },
        });

        this.foreignBuyerLayer.visibility = false;

        this.map.on('zoomend', () => {
            if (this.config.ForeignBuyerBanLayer.active) {
                this.handleAddForeignBuyerLand();
            }
        });

        const addFunction = this.addForeignBuyerBanLayerToLayerManager;
        if (geoJSONData !== null && response.ok === true) {
            addFunction();
        }
    }

    public addCrownLandLayerToLayerManager() {
        this.layers.push(Object.assign({}, this.config.CrownLandLayer));
    }

    public addForeignBuyerBanLayerToLayerManager() {
        this.layers.push(Object.assign({}, this.config.ForeignBuyerBanLayer));
    }

    public onHeatmapDataLoaded() {
        if (this.heatmapData) {
            // @ts-ignore - L.HeatLayer types aren't working ?!
            this.layerSoldHeatMap = L.heatLayer(this.heatmapData, { radius: 25, maxZoom: 17 });
        }
    }

    // input is basemap config object
    public onBasemapSelect(basemap: any) {
        console.log('onBasemapSelect');
        if (basemap.active) {
            return;
        }

        for (const [key, value] of Object.entries(this.basemaps)) {
            (value as any).active = false;
        }

        if (this.activeBasemap) {
            this.map.removeLayer(this.activeBasemap);
        }

        this.$store.dispatch('sendBasemapEvent', { action: basemap.name });

        basemap.active = true;
        if (basemap.name === 'Imagery_Bing') {
            // @ts-ignore
            this.activeBasemap = new L.BingLayer(basemap.key, {type: basemap.type}).addTo(this.map);
        } else if (basemap.name === 'MapBox') {
            // @ts-ignore - no types for mapboxGL installed
            this.activeBasemap = L.mapboxGL({
                accessToken: this.config.mapBoxToken,
                style: basemap.style,
                maxZoom: basemap.options.maxZoom,
            }).addTo(this.map);
        } else if (basemap.hasOwnProperty('urlTemplate')) {
            this.activeBasemap = L.tileLayer(basemap.urlTemplate, {
                maxZoom: basemap.options.maxZoom,
            }).addTo(this.map);
        } else if (basemap.hasOwnProperty('url')) {
            this.activeBasemap = esri.tiledMapLayer({
                url: basemap.url,
                maxZoom: basemap.options.maxZoom,
            }).addTo(this.map);
        } else {
            this.activeBasemap = esri.basemapLayer(basemap.name).addTo(this.map);
        }

        if (basemap.name === 'Imagery_GeoNova' || basemap.name === 'Imagery') {
            this.parcelVectorLayer.removeFrom(this.map);
            // @ts-ignore - no types
            this.parcelVectorLayer = L.mapboxGL({
                style: this.config.ParcelVectorTileLayer.styleWhite,
                attribution: ' Built by <a href="https://www.mapdev.ca" target="_blank">MapDev</a>',
                pane: 'vector',
            }).addTo(this.map);
        } else {
            this.parcelVectorLayer.removeFrom(this.map);
            // @ts-ignore - no types
            this.parcelVectorLayer = L.mapboxGL({
                style: this.config.ParcelVectorTileLayer.styleNormal,
                attribution: ' Built by <a href="https://www.mapdev.ca" target="_blank">MapDev</a>',
                pane: 'vector',
            }).addTo(this.map);
        }

        if (this.activeBasemapLabels) {
            this.map.removeLayer(this.activeBasemapLabels);
        }

        if (basemap.name === 'ShadedRelief' ||
            basemap.name === 'Oceans' ||
            basemap.name === 'Gray' ||
            basemap.name === 'DarkGray' ||
            basemap.name === 'Imagery' ||
            basemap.name === 'Terrain') {
            // @ts-ignore - esri types don't like it, but its good
            this.activeBasemapLabels = esri.basemapLayer(basemap.name + 'Labels');
            this.map.addLayer(this.activeBasemapLabels);
        }

        this.layerMenuShowing = false;
    }

    // TODO this could be made a little more generic to handle other layers
    public onLayerToggle(layer: any) {
        console.log('onLayerToggle');

        // Logger.writeLog("LayerMgr:chkBoxListingPoints");
        if (layer.name === this.config.ListingsPointLayer.name) {
            if (layer.active) {
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_LISTPNTSON});
                this.map.addLayer(this.pointOpsLayer);
            } else {
                this.map.removeLayer(this.pointOpsLayer);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_LISTPNTSOFF});
            }
        }

        if (layer.name === this.config.HeatmapLayer.name) {
            if (layer.active) {
                this.map.addLayer(this.layerSoldHeatMap);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_HEATON});
            } else {
                this.map.removeLayer(this.layerSoldHeatMap);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_HEATOFF});
            }
        }

        if (layer.name === this.config.CrimeRecordsLayer.name) {
            if (this.crimeLayer === null) {
                return;
            }
            if (layer.active) {
                this.map.addLayer(this.crimeLayer);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_CRIMEON});
            } else {
                this.map.removeLayer(this.crimeLayer);
                if (this.selectedCrimeMarker) {
                    this.map.removeLayer(this.selectedCrimeMarker);
                }
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_CRIMEOFF});
            }
        }

        if (layer.name === this.config.CrownLandLayer.name) {
            if (this.crownLandLayer === null) {
                return;
            }
            if (layer.active) {
                this.map.addLayer(this.crownLandLayer);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_CROWNLANDON});
            } else {
                this.map.removeLayer(this.crownLandLayer);
                this.$store.dispatch('sendOpsLayerEvent', { action: Defs.ANALYTICS_OPSLAYER_CROWNLANDOFF});
            }
        }

        if (layer.name === this.config.ForeignBuyerBanLayer.name) {
            if (this.foreignBuyerLayer === null) {
                return;
            }
            if (layer.active) {
                this.config.ForeignBuyerBanLayer.active = true;
                this.handleAddForeignBuyerLand();
            } else {
                this.config.ForeignBuyerBanLayer.active = false;
                this.foreignBuyerLayer.visibility = false;
                this.map.removeLayer(this.foreignBuyerLayer);
            }
        }
    }

    public onLayerInfo(tooltip: string) {
        console.log('onLayerInfo');
        if (tooltip.length > 100) {
            console.log(tooltip);
            // TODO Needs formatting
            this.$q.dialog({
                title: 'Info',
                message: tooltip,
            }).onOk(() => {
            // console.log('OK')
            }).onCancel(() => {
            // console.log('Cancel')
            }).onDismiss(() => {
            // console.log('I am triggered on both OK and Cancel')
            });
        }
    }

    public initLayers() {
        this.initBaseLayers();
        this.initTileLayers();
        this.initOpsLayers();
        this.initSelectedFeatureMarker();
        this.initSelectedCrimeMarker();
        this.initQueryParams();
    }

    public initQueryParams() {
        const sysId = this.$route.query.sid as string;
        const pid = this.$route.query.pid as string;
        const lat = this.$route.query.lat as string;
        const lon = this.$route.query.lon as string;
        if (sysId) {
            this.onGoToListing(parseInt(sysId, 10));
        } else if (pid) {
            if (pid.length === 8) {
                this.$store.dispatch('goToParcel', pid);
            }
        } else if (lat && lon) {
            const latLon = new L.LatLng(parseFloat(lat), parseFloat(lon));
            this.$store.dispatch('setMarkerLocation', latLon);
            this.$store.dispatch('goToLatLon', latLon);
        }
    }

    public isWebGLSupported(): boolean {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (gl && gl instanceof WebGLRenderingContext) {
            return true;
        }
        return false;
    }

    public initBaseLayers() {
        const lBasemap: esri.Basemaps = (this.config.mapDefault.basemap) as L.esri.Basemaps;
        if (this.isWebGLSupported()) {
            // @ts-ignore - no types for mapboxGL installed
            this.activeBasemap = L.mapboxGL({
                accessToken: this.config.mapBoxToken,
                style: this.config.basemapLayers.MapBox.style,
                maxZoom: this.config.basemapLayers.MapBox.options.maxZoom,
            }).addTo(this.map);
            this.map.attributionControl.setPrefix('<a href="https://www.mapbox.com/about/maps/" style="color:black" target="_blank">© Mapbox</a> | <a href="http://www.openstreetmap.org/copyright" style="color:black" target="_blank">© OpenStreetMap</a> | <a href="https://www.mapbox.com/map-feedback/" style="color:black" target="_blank">Improve this map</a> | Powered by <a href="https://www.esri.com" target="_blank" style="color:black">Esri</a>');
            this.basemaps = Object.assign({}, this.$store.state.config.basemapLayers);
            this.basemaps.MapBox.active = true;
        } else {
            this.activeBasemap = esri.basemapLayer(lBasemap).addTo(this.map);
            this.map.attributionControl.setPrefix('Powered by <a href="https://www.esri.com" target="_blank" style="color:black">Esri</a>');
            this.basemaps = Object.assign({}, this.$store.state.config.basemapLayers);
            // @ts-ignore
            delete this.basemaps.MapBox;
            this.basemaps.Streets.active = true;
        }
    }

    public initTileLayers() {
        console.log('initTileLayers');
        // Logger.writeLog("_initTileLayers");

        this.map.createPane('vector');
        const vectorPane = this.map.getPane('vector');
        if (vectorPane) {
            vectorPane.style.zIndex = '300';
        }


        // @ts-ignore - no types for mapboxGL installed
        this.parcelVectorLayer = L.mapboxGL({
            style: this.config.ParcelVectorTileLayer.styleNormal,
            attribution: ' Built by <a href="https://www.mapdev.ca" target="_blank">MapDev</a>',
            // NOTE: don't include min/max zoom here, it messes with the spec
            pane: 'vector',
        }).addTo(this.map);

    }

    public initOpsLayers() {
        // Logger.writeLog("_initOpsLayers");
        // Logger.writeLog("Init Listing Polygon Layer");

        console.log('_initOpsLayers');

        console.log('Init Listing Points Layer');
        this.listingPointsLayer = esri.featureLayer({
            url: this.config.ListingsPointLayer.url,
            isModern: true,
        });

        console.log('Init Listing Polygon Layer');
        this.listingPolygonLayer = esri.featureLayer({
            url: this.config.ListingsPolygonLayer.url,
            fields: this.config.ListingsPolygonLayer.outFields,
            where: this.config.ListingsPolygonLayer.definitionExpression,
            minZoom: this.config.ListingsPolygonLayer.minZoom,
            maxZoom: this.config.ListingsPolygonLayer.maxZoom,
            simplifyFactor: this.config.ListingsPolygonLayer.simplifyFactor,
            isModern: true,
            precision: this.config.ListingsPolygonLayer.precision,
            style: (feature) => {
                if (feature.properties.st === '2') {
                    return { color: 'darkred', weight: 2, fillOpacity: 0 };
                } else if (feature.properties.st === '23' || feature.properties.st === '3') {
                    return { color: 'darkgoldenrod', weight: 2, fillOpacity: 0 };
                } else {
                    return { color: '#002b78', weight: 2, fillOpacity: 0 };
                }
            },
        });

        this.listingPolygonLayer.on('click', this.onListingPolygonClick);

        this.listingPolygonLayer.on('loading', this.onListingPolygonLoadingStarted);

        this.listingPolygonLayer.on('load', this.onListingPolygonLoaded);

        // Logger.writeLog("Init Listing Point Layer");
        console.log('Init Listing Point Layer');

        this.pointOpsLayer = esriCluster.featureLayer({
            url: this.config.ListingsPointLayer.url,
            fields: this.config.ListingsPointLayer.outFields,
            where: this.config.ListingsPointLayer.definitionExpression,
            minZoom: this.config.ListingsPointLayer.minZoom,
            maxZoom: this.config.ListingsPointLayer.maxZoom,
            errorCb: this.onPointLayerError,
            chunkedLoading: true,
            spiderfyOnMaxZoom: false,
            animate: false,
            isModern: true,
            disableClusteringAtZoom: 16,
            polygonOptions: {
                color: '#626366',
                weight: 4,
                opacity: 1,
                fillOpacity: 0.5,
            },
            // this function defines how the icons
            // representing  clusters are created
            iconCreateFunction: (cluster: any) => {
                // get the number of items in the cluster
                const count = cluster.getChildCount();

                // figure out how many digits long the number is
                const digits = (count + '').length;

                // return a new L.DivIcon with our classes so we can
                // style them with CSS. Take a look at the CSS in
                // the <head> to see these styles. You have to set
                // iconSize to null if you want to use CSS to set the
                // width and height.
                return new L.DivIcon({
                    html: count,
                    className: 'cluster digits-' + digits,
                    iconSize: undefined,
                });
            },
            // TODO types please
            pointToLayer: (feature: any, latlng: any) => {
                const lMarkerHtml = this.getListingLabel(feature);

                return L.marker(latlng,
                    {
                        icon: L.divIcon({
                            iconSize: undefined,
                            className: 'label',
                            iconAnchor: [24, 10],
                            html: lMarkerHtml,
                        }),
                    });
            },
        });


        this.pointOpsLayer.on('loading', this.onListingPointsLoadingStarted);

        this.pointOpsLayer.on('load', this.onListingPointsLoaded);

        this.pointOpsLayer.on('click', this.onListingPointClick);

        this.pointOpsLayer.addTo(this.map);
        this.listingPolygonLayer.addTo(this.map);
    }

    public onListingPolygonLoadingStarted() {
        this.listingPolygonErrorTracking.IsErrorOnCurrentLoad = false;
    }

    public onListingPolygonLoaded() {
        if (this.listingPolygonLayer) {
            this.updateLayerErrorTracking(this.listingPolygonErrorTracking, this.listingPolygonLayer);
        }
    }

    public onListingPointClick(event: L.LeafletMouseEvent) {
        // Logger.writeLog("_onListingPointClick");
        console.log('_onListingPointClick');
        this.lastListingLayerSelected = event.layer;
        this.handleLisitngFeatureClick(event.layer);
    }

    public onCrimePointClick(event: L.LeafletMouseEvent) {
        // Logger.writeLog("_onCrimePointClick");
        console.log('_onCrimePointClick');
        this.handleCrimeFeatureClick(event.layer);
    }

    public onPointLayerError(error: any) {
        console.error('onPointLayerError');
        console.error(error);
        this.listingPointErrorTracking.IsErrorOnCurrentLoad = true;
        this.listingPointErrorTracking.LatestError = error;
    }

    public onListingPointsLoadingStarted() {

        // Logger.writeLog("_onListingPointsLoadingStarted");
        console.log('_onListingPointsLoadingStarted');

        const loaderElement: Element = document.getElementsByClassName('divLayerLoading')[0];
        loaderElement.setAttribute('style', 'display: block');

        this.loadingTimerId = setTimeout(() => {
            // there is a bug in esri.featureLayer where its not hitting the loaded event if the
            // browser cancels or uses a cached result so the spinner will never go away
            loaderElement.setAttribute('style', 'display: none');
        }, 5000);

        this.isListingPointLayerLoading = true;
        this.listingPointErrorTracking.IsErrorOnCurrentLoad = false;
    }

    public onListingPointsLoaded() {

        // Logger.writeLog("_onListingPointsLoaded");
        console.log('_onListingPointsLoaded');

        const loaderElement: Element = document.getElementsByClassName('divLayerLoading')[0];
        loaderElement.setAttribute('style', 'display: none');
        if (this.loadingTimerId) {
            clearTimeout(this.loadingTimerId);
        }
        this.loadingTimerId = null;

        this.updateLayerErrorTracking(this.listingPointErrorTracking, this.pointOpsLayer);

        this.isListingPointLayerLoading = false;

        // Check for pending filter changes and apply if needed
        if (this.hasPendingFilterUpdate) {
            this.updateFilter();
            this.hasPendingFilterUpdate = false;
        }

        // Need to check for pending selected listing changes
        // that were attempted during the layer load.
        if (this.pendingNewSelectedListingPid !== null) {
            this.selectListingOnMapByPid(this.pendingNewSelectedListingPid);
            this.pendingNewSelectedListingPid = null;
        }

        this.notifyNewFeaturesLoadedIntoMapBounds();
    }


    public updateLayerErrorTracking(errorTracker: any, featureLayer: esri.FeatureLayer) {

        // Increment num of load errors if one occured during the current layer
        // load
        if (errorTracker.IsErrorOnCurrentLoad === true) {
            errorTracker.NumLoadsInRowWithError++;
            setTimeout(() => { featureLayer.refresh(); }, errorTracker.DelayToNextRefresh);
        } else {
            errorTracker.NumLoadsInRowWithError = 0;
            errorTracker.DelayToNextRefresh = 100;
        }

        if (errorTracker.NumLoadsInRowWithError === 5) {
            if (errorTracker.HasErrorBeenDisplayed === false) {
                // TODO ErrorMgr
                // ErrorMgr.showLayerDrawError(errorTracker.LatestError);
                errorTracker.HasErrorBeenDisplayed = true;
            }
            errorTracker.DelayToNextRefresh *= 10;
            errorTracker.NumLoadsInRowWithError = 0;
        }
    }

    public onListingPolygonClick(event: L.LeafletMouseEvent) {
        // Stops the click event from hitting other callbacks
        event.originalEvent.preventDefault();
        console.log('_onListingPolygonClick');
        this.lastListingLayerSelected = event.layer;
        this.handleLisitngFeatureClick(event.layer);
    }

    public handleLisitngFeatureClick(layer: any) {
        // Logger.writeLog("LayerMge:_handleLisitngFeatureClick");
        console.log('LayerMge:_handleLisitngFeatureClick');

        // Multi-listing, need to fire event so popup opens
        // allowing selection of specific listing
        if (layer.feature.properties.ml === 1) {
            this.$store.dispatch('multiListingSelectedViaMap', layer);
        } else {

            // Otherwise, single listing so change selected listing
            this.$store.dispatch('sendListingEvent', {action: Defs.ANALYTICS_LISTING_MAPCLICK, sysId: layer.feature.properties.sid});
            const selectedListing = new Listing(layer.feature.properties);
            this.$store.dispatch('setSelectedListing', selectedListing);

            this.$store.dispatch('singleListingSelectedViaMap', layer);
        }
    }

    public handleCrimeFeatureClick(layer: any) {
        // Logger.writeLog("LayMge:_handleCrimeFeatureClick");
        console.log('LayMge:_handleCrimeFeatureClick');
        this.$store.dispatch('changeSelectedCrime', new CrimePoint(layer.feature.properties));
        this.$store.dispatch('showCrimeDialog');
        this.setSelectedCrimeMarkerCoordinates(layer.getLatLng());
    }

    public setSelectedCrimeMarkerCoordinates(latLon: L.LatLng) {
        console.log('setSelectedCrimeMarkerCoordinates');
        if (this.selectedCrimeMarker) {
            if (this.map.hasLayer(this.selectedCrimeMarker)) {
                this.selectedCrimeMarker.setLatLng(latLon);
            } else {
                this.selectedCrimeMarker.setLatLng(latLon);
                this.selectedCrimeMarker.addTo(this.map);
            }
        }
    }

    public getListingLabel(feature: any) {

        let lPrice = Defs.LISTING_NO_VALUE;

        // if (feature.properties.md !== null && feature.properties.mli !== null) {
        if (feature.properties.ml === 1) {
            const allMListings = JSON.parse(feature.properties.md);
            const forSaleAndPendingListings = [];

            for (let i = 0; i < allMListings.length; i++) {
                if (allMListings[i].st === '1' || allMListings[i].st === '1_0'
                    || allMListings[i].st === '3' || allMListings[i].st === '3_0') {
                    forSaleAndPendingListings.push(allMListings[i]);
                }
            }

            let lowestPrice = forSaleAndPendingListings[0].lpmn;
            for (let i = 0; i < forSaleAndPendingListings.length; i++) {
                if (forSaleAndPendingListings[i].lpmn < lowestPrice) {
                    lowestPrice = forSaleAndPendingListings[i].lpmn;
                }
            }

            lPrice = ListingUtil.getPriceShortened(lowestPrice, 1);
        } else {
            if (feature.properties.st === '2' && this.isLoggedIn === false) {
                lPrice = 'SOLD';
            } else if (feature.properties.st === '2') {
                if (feature.properties.sp === null || feature.properties.sp === 0) {
                    lPrice = ListingUtil.getPriceShortened(feature.properties.lpmn, feature.properties.ml);
                } else {
                    lPrice = ListingUtil.getPriceShortened(feature.properties.sp, feature.properties.ml);
                }
            } else {
                lPrice = ListingUtil.getPriceShortened(feature.properties.lpmn, feature.properties.ml);
            }
        }

        let lHtml = '';

        if (feature.properties.ml === 1 && feature.properties.st.length > 1) {
            lHtml = this.getMultiListingLabelHtml(lPrice, feature.properties.st);
        } else {
            lHtml = '<div class="' + this.getLabelClassFromStatus(feature.properties.st) + '">' + lPrice + '</div>';
        }

        return lHtml;
    }

    public getMultiListingLabelHtml(price: string, listStatus: string) {
        let classFromStaus = this.getLabelClassFromStatus(listStatus);

        if (listStatus !== null && listStatus.length > 1) {

            classFromStaus = classFromStaus + ' adjustPaddingForMulti';
        }

        let lHtml = '<div class="' + classFromStaus + '" ><div>' + price + '</div><div>';

        // @ts-ignore FIX
        for (let i = 1; i < listStatus.length; i++) {
            if (listStatus.charAt(i) === '2') {
                lHtml += '<div class="markerMultiSOLD"></div>';
            } else if (listStatus.charAt(i) === '3') {
                lHtml += '<div class="markerMultiPENDING"></div>';
            }
        }

        lHtml += '</div></div>';
        return lHtml;
    }


    public getLabelClassFromStatus(status: string) {

        if (status === '1' ||
            status === '12' ||
            status === '123' ||
            status === '13' ||
            status === '23') {
            return 'lblSingleListing remaxblue';
        } else if (status === '2') {
            return 'lblSingleListing remaxred';
        } else if (status === '23' ||
                status === '3') {
            return 'lblSingleListing remaxyellow';
        } else {
            return 'lblSingleListing remaxblue';
        }
    }

    public initSelectedFeatureMarker() {
        // Logger.writeLog("_initSelectedFeatureMarker");
        console.log('_initSelectedFeatureMarker');

        const myIcon = L.icon({
            iconUrl: 'https://data.remaxnova.com/propimages/map/pins/res.png',
            iconAnchor: [20, 58], // point of the icon which will correspond to marker's location
        });

        this.map.createPane('selectedListing');

        const selectedListedPane = this.map.getPane('selectedListing');

        if (selectedListedPane) {
            selectedListedPane.style.zIndex = '650';
        }

        this.selectedFeatureMarker = L.marker([44.662143, -63.597600], { icon: myIcon, pane: 'selectedListing' });
    }

    public initSelectedCrimeMarker() {
        // Logger.writeLog("_initSelectedCrimeMarker");
        console.log('_initSelectedCrimeMarker');

        const myIcon = L.icon({
            iconUrl: 'https://data.remaxnova.com/propimages/map/pins/crime_sel.png',
            iconAnchor: [20, 20], // point of the icon which will correspond to marker's location
            iconSize: [33, 35],
        });

        this.map.createPane('selectedCrime');
        const selectedCrimePane = this.map.getPane('selectedListing');
        if (selectedCrimePane) {
            selectedCrimePane.style.zIndex = '450';
        }

        this.selectedCrimeMarker = L.marker([44.662143, -63.597600], { icon: myIcon, pane: 'selectedCrime' });

        this.selectedCrimeMarker.on('click', this.onSelectedCrimeClick);
    }

    public onSelectedCrimeClick(data: L.LeafletMouseEvent) {
        console.log('onSelectedCrimeClick');
        if (this.selectedCrimeMarker && this.lastListingLayerSelected !== null) {
            this.map.removeLayer(this.selectedCrimeMarker);
            this.handleLisitngFeatureClick(this.lastListingLayerSelected);
        }
    }

    public onSelectedListingChanged(listing: Listing) {

        // Logger.writeLog("LayerMgr:_onSelectedListingChanged");
        console.log('LayerMgr:_onSelectedListingChanged');

        // If the point layer is still loading there is the
        // chance that the selected point is not there yet so
        // store it as pending so it can be selected once the load is
        // done.
        if (this.isListingPointLayerLoading === true) {
            this.pendingNewSelectedListingPid = listing.pid;
            return;
        }

        this.selectListingOnMapByPid(listing.pid);
    }

    public selectListingOnMapByPid(pid: string) {
        // Logger.writeLog("LayerMgr:_selectListingOnMapByPid");
        console.log('LayerMgr:_selectListingOnMapByPid');
        this.moveSelectedListingMarkerByPid(pid);
        this.highlightSelectedListingParcel(pid);
    }

    public moveSelectedListingMarkerByPid(pid: string) {
        const lBounds = this.map.getBounds();
        let lIsFound = false;
        this.pointOpsLayer.eachFeature((layer: any) => {
            if (lBounds.contains(layer._latlng)) {
                if (layer.feature.properties.pid === pid) {
                    this.setSelectedFeatureMarkerCoordinates(layer._latlng);
                    lIsFound = true;
                }
            }
        });

        // May not find the pid by the point if a filter was set and
        // the click was done on the polygon
        if (this.listingPolygonLayer && lIsFound === false) {
            this.listingPolygonLayer.eachFeature((layer) => {
                const lCenter = layer.getBounds().getCenter();
                if (lBounds.contains(lCenter)) {
                    if (layer.feature.properties.pid === pid) {
                        this.setSelectedFeatureMarkerCoordinates(lCenter);
                        lIsFound = true;
                    }
                }
            });
        }
    }

    public setSelectedFeatureMarkerCoordinates(latLon: L.LatLng) {
        if (this.selectedFeatureMarker) {
            if (this.map.hasLayer(this.selectedFeatureMarker)) {
                this.selectedFeatureMarker.setLatLng(latLon);
            } else {
                this.selectedFeatureMarker.setLatLng(latLon);
                this.selectedFeatureMarker.addTo(this.map);
            }

            if (this.selectedCrimeMarker) {
                this.map.removeLayer(this.selectedCrimeMarker);
            }
        }
    }

    public highlightSelectedListingParcel(pid: string) {

        // Logger.writeLog("_highlightSelectedListingParcel");
        console.log('_highlightSelectedListingParcel');

        // Clear any selected parcel
        if (this.selectedParcelLayer) {
            this.selectedParcelLayer.removeFrom(this.map);
        }

        if (this.listingPolygonLayer) {
            this.listingPolygonLayer.eachFeature((layer) => {
                if (this.listingPolygonLayer && layer.feature.properties.pid === pid) {

                    if (this.currentlyHighlightedPolygonId) {
                        // @ts-ignore - this is valid
                        this.listingPolygonLayer.resetStyle(this.currentlyHighlightedPolygonId);
                    }

                    this.listingPolygonLayer.setFeatureStyle(layer.feature.properties.OBJECTID, this.config.highlightedListingColor);
                    this.currentlyHighlightedPolygonId = layer.feature.properties.OBJECTID;
                }
            });
        }
    }

    public addClauseToWhere(where: string | null, newClause: string) {
        if (where === null || where === '') {
            where = newClause;
        } else {
            where = where + ' and ' + newClause;
        }
        return where;
    }

    public addClauseToWhereWithOr(where: string | null, newClause: string) {
        if (where === null || where === '') {
            where = newClause;
        } else {
            where = where + ' or ' + newClause;
        }
        return where;
    }

    public onFilterChanged() {
        this.updateFilter();
    }

    // TODO this should eventually get moved to filterStore actions
    public updateFilter() {
        console.log('LayerManager: updateFilter()');
        console.log(this.activeFilter);

        // Want to precent setting a where clause on the feature layer
        // while it is updating because current requests coming in with botch the filter.
        // if (this.isListingPointLayerLoading === true) {
        //     console.log('isListingPointLayerLoading===true');
        //     this.hasPendingFilterUpdate = true;
        //     return;
        // }
        // this.hasPendingFilterUpdate = false;

        let lWhere: string | null = null;

        let lNumFilters: number = 0;

        // Price
        let iFilterSet = false;
        if (this.activeFilter.Price.Min !== this.config.FilterOptions.PriceNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'lpmx >= ' + this.activeFilter.Price.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Price.Max !== this.config.FilterOptions.PriceNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'lpmn <= ' + this.activeFilter.Price.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Beds
        iFilterSet = false;
        if (this.activeFilter.Beds.Min !== this.config.FilterOptions.BedNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'bdmx >= ' + this.activeFilter.Beds.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Beds.Max !== this.config.FilterOptions.BedNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'bdmn <= ' + this.activeFilter.Beds.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Baths
        iFilterSet = false;
        if (this.activeFilter.Baths.Min !== this.config.FilterOptions.BathNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'bhmx >= ' + this.activeFilter.Baths.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Baths.Max !== this.config.FilterOptions.BathNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'bhmn <= ' + this.activeFilter.Baths.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Mla
        iFilterSet = false;
        if (this.activeFilter.Mla.Min !== this.config.FilterOptions.MlaNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'mlax >= ' + this.activeFilter.Mla.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Mla.Max !== this.config.FilterOptions.MlaNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'mlan <= ' + this.activeFilter.Mla.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Tla
        iFilterSet = false;
        if (this.activeFilter.Tla.Min !== this.config.FilterOptions.TlaNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'tlax >= ' + this.activeFilter.Tla.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Tla.Max !== this.config.FilterOptions.TlaNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'tlan <= ' + this.activeFilter.Tla.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Lot Size
        iFilterSet = false;
        if (this.activeFilter.LotSize.Min !== this.config.FilterOptions.LotSizeNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'pls >= ' + this.activeFilter.LotSize.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.LotSize.Max !== this.config.FilterOptions.LotSizeNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'pls <= ' + this.activeFilter.LotSize.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Age
        iFilterSet = false;
        if (this.activeFilter.Age.Min !== this.config.FilterOptions.AgeNoMinVal) {
            lWhere = this.addClauseToWhere(lWhere, 'yb >= ' + this.activeFilter.Age.Min);
            iFilterSet = true;
        }
        if (this.activeFilter.Age.Max !== this.config.FilterOptions.AgeNoMaxVal) {
            lWhere = this.addClauseToWhere(lWhere, 'yb <= ' + this.activeFilter.Age.Max);
            iFilterSet = true;
        }
        if (iFilterSet) {
            lNumFilters++;
        }

        // Waterfront
        if (this.activeFilter.Waterfront.value !== null) {
            lWhere = this.addClauseToWhere(lWhere, 'wf = 1');
            lNumFilters++;
        }

        // Garage
        if (this.activeFilter.Garage.value !== null) {
            lWhere = this.addClauseToWhere(lWhere, 'ga = 1');
            lNumFilters++;
        }

        // Class
        if (this.activeFilter.Class !== null && this.activeFilter.Class.value !== null && this.activeFilter.Class.value.length !== 0 &&
            this.activeFilter.Class.value.length !== this.config.FilterOptions.ClassOptions.length) {
            let lClassWhere = '';
            for (let i = 0; i < this.activeFilter.Class.value.length; i++) {
                lClassWhere = this.addClauseToWhereWithOr(lClassWhere, 'cl = ' + this.activeFilter.Class.value[i]);
            }

            lWhere = this.addClauseToWhere(lWhere, '(' + lClassWhere + ')');
            lNumFilters++;
        }

        // HeatType
        if (this.activeFilter.HeatType !== null && this.activeFilter.HeatType.value !== null  && this.activeFilter.HeatType.value.length !== 0
        && this.activeFilter.HeatType.value.length !== this.config.FilterOptions.HeatTypeOptions.length) {
            let lHeatTypeWhere = '';
            for (let b = 0; b < this.activeFilter.HeatType.value.length; b++) {
                lHeatTypeWhere = this.addClauseToWhereWithOr(lHeatTypeWhere, `ht like '%` + this.activeFilter.HeatType.value[b]) + `%'`;
            }

            lWhere = this.addClauseToWhere(lWhere, '(' + lHeatTypeWhere + ')');
            lNumFilters++;
        }

        // Style
        if (this.activeFilter.Style !== null && this.activeFilter.Style.value !== null && this.activeFilter.Style.value.length !== 0 &&
            this.activeFilter.Style.value.length !== this.config.FilterOptions.StyleOptions.length) {
            let lStyleWhere = '';
            for (let j = 0; j < this.activeFilter.Style.value.length; j++) {
                lStyleWhere = this.addClauseToWhereWithOr(lStyleWhere, `sty = '` + this.activeFilter.Style.value[j]) + `'`;
            }
            lWhere = this.addClauseToWhere(lWhere, '(' + lStyleWhere + ')');
            lNumFilters++;
        }

        // Status
        if (this.activeFilter.Status !== null && this.activeFilter.Status.value !== null && this.activeFilter.Status.value.length !== 0 &&
            this.activeFilter.Status.value.length !== this.config.FilterOptions.StatusOptions.length) {
            let lStatusWhere = '';
            for (let k = 0; k < this.activeFilter.Status.value.length; k++) {
                lStatusWhere = this.addClauseToWhereWithOr(lStatusWhere, `st like '%` + this.activeFilter.Status.value[k]) + `%'`;
            }
            lWhere = this.addClauseToWhere(lWhere, '(' + lStatusWhere + ')');
            if (this.activeFilter.Status.value.length === 2 && this.activeFilter.Status.value[0] !== '2' && this.activeFilter.Status.value[1] !== '2') {
                // do nothing, the default is For sale and pending
            } else {
                lNumFilters++;
            }
        }

        // Type
        if (this.activeFilter.Type !== null && this.activeFilter.Type.value !== null && this.activeFilter.Type.value.length !== 0 &&
        this.activeFilter.Type.value.length !== (this.config.FilterOptions.ResidentialTypeOptions.length + this.config.FilterOptions.CommercialTypeOptions.length)) {
            let lTypeWhere = '';
            for (let d = 0; d < this.activeFilter.Type.value.length; d++) {
                lTypeWhere = this.addClauseToWhereWithOr(lTypeWhere, 'ty = ' + this.activeFilter.Type.value[d]);
            }

            lWhere = this.addClauseToWhere(lWhere, '(' + lTypeWhere + ')');
            lNumFilters++;
        }

        // SpatialFilter
        if (this.spatialFilter) {
            console.log('Adding spatial query');
            lNumFilters++;

            // Do query here and set spatial filter as list of IDs.
            const query = esri.query({
                url: this.config.ListingsPointLayer.url_in,
            });

            if (lWhere === null) {
                lWhere = '1=1';
            }

            // this.map.removeLayer(this.pointOpsLayer);
            // @ts-ignore
            query.intersects(L.geoJSON(JSON.parse(this.spatialFilter))).where(lWhere).ids((error: any, ids: any, response: any) => {
                if (!error) {
                    console.log(response);
                    console.log(ids);
                    const filteredIds: any = {};
                    for (let z = 0; z < ids.length; z++) {
                        filteredIds[ids[z]] = 1;
                    }
                    console.log('OBJECTID in ('  + response.objectIds.join(`,`) + ')');
                    // TODO setSpatialFilter() does not exist on featureLayer. Was this a kpower custom?
                    // workaround is to create a where clause based on the objectids
                    // this.pointOpsLayer.setSpatialFilter(filteredIds);
                    this.pointOpsLayer.setWhere('OBJECTID in ('  + response.objectIds.join(`,`) + ')');

                    // this.map.addLayer(this.pointOpsLayer);
                } else {
                    // ErrorMgr.logError("failed to get School:" + error);
                    console.error('failed to get School:' + error);
                    this.map.addLayer(this.pointOpsLayer);
                }
            });

            // TODO setSpatialFilter() does not exist on featureLayer. Was this a kpower custom?
            // this.pointOpsLayer.setSpatialFilter(this.filters.schoolCatchment);

            // this.filterSpatial = this.spatialFilter;
            // this.filterSpatial = L.geoJson(filter.SchoolCatchment);

        } else {
            // TODO clearSpatialFilter() does not exist on featureLayer. Was this a kpower custom?
            // this.pointOpsLayer.clearSpatialFilter();
            console.log(lWhere);
            this.pointOpsLayer.setWhere(lWhere);
        }

        this.$store.dispatch('setFilterNumber', lNumFilters);
        this.$store.dispatch('sendFilterEvent', { filter: lWhere });
    }

    public getPointFeaturesWithinCurrentBounds() {
        // Logger.writeLog("_getFeaturesWithinCurrentBounds");
        console.log('_getFeaturesWithinCurrentBounds');

        const lBounds = this.map.getBounds();
        const listings: Listing[] = [];
        const lSnapshot = this.pointOpsLayer._currentSnapshot; // getCurrentSnapshot(); <= this was a kpower change in esri-leaflet.js. Was there more??
        this.pointOpsLayer.eachFeature((layer: any) => {
            if (lBounds.contains(layer._latlng) && -1 !== lSnapshot.indexOf(layer.feature.id)) {
                listings.push(new Listing(layer.feature.properties));
            }
        });

        console.log(listings);
        return listings;
    }


    public notifyNewFeaturesLoadedIntoMapBounds() {
        // Logger.writeLog("_notifyNewFeaturesLoadedIntoMapBounds");
        console.log('_notifyNewFeaturesLoadedIntoMapBounds');
        const listings = this.getPointFeaturesWithinCurrentBounds();
        if (this.map.getZoom() >= 14) {
            listings.forEach( (listing) => {
                if (listing.sid !== null) {
                    PreloadImage(this.$store.state.config.imageRoot + listing.pi);
                    // not sure if we want to bother preloading the _map image too
                    // PreloadImage(this.$store.state.config.imageRoot + ListingUtil.addMapPostfixToImage(listing.pi));
                }
            });
        }
        this.$store.dispatch('setListingsInMapBounds', listings);
    }

    public onGoToListing(systemId: number) {
        console.log('onGoToListing');
        const where = `sid=` + systemId + ` or mli like '%` + systemId + `%'`;
        this.listingPointsLayer?.query()
        .where(where)
        .run((error, featureCollection) => {
            const feature = ListingUtil.getListingFromResult(featureCollection, systemId);
            if (feature === null) {
                // ErrorMgr.showError("Unable to find listing: " + systemId, data.error);
                console.error('null listing');
                this.$store.dispatch('notify', 'Unable to find listing: ' + systemId);
                return;
            }
            const latLng = L.latLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
            this.map.setView(latLng, 16);

            const listing = new Listing(feature.properties);
            this.$store.dispatch('setSelectedListing', listing);
            this.$store.dispatch('popupSingleListing', {listing, latLng});
            // RemapState.changeSelectedListing(listing.properties);

            // This is redundant if the listing is already in the map bounds.
            // The call to RemapState.changeSelectedListing will attempt to move the
            // marker so this is called in the event it fails.
            // RemapState.setMarkerCoordinates(latlng);
            this.setSelectedFeatureMarkerCoordinates(latLng);
        });
    }

    public mounted() {
        console.log('LayerManager: mounted()');
    }

    public beforeDestroy() {
        console.log('LayerManager: destroying()');
        this.unsubscribe();
    }

    private handleAddForeignBuyerLand() {
        const currentZoom = this.map.getZoom();
        if (currentZoom >= this.config.ForeignBuyerBanLayer.minZoom &&
            currentZoom <= this.config.ForeignBuyerBanLayer.maxZoom &&
            !this.foreignBuyerLayer.visibility) {
            this.map.addLayer(this.foreignBuyerLayer);
            this.foreignBuyerLayer.visibility = true;
        } else if (!(currentZoom >= this.config.ForeignBuyerBanLayer.minZoom &&
                    currentZoom <= this.config.ForeignBuyerBanLayer.maxZoom) &&
                    this.foreignBuyerLayer.visibility) {
            this.map.removeLayer(this.foreignBuyerLayer);
            this.foreignBuyerLayer.visibility = false;
        }
    }
}
